<div class="svg-laptop">
  <div class="box"
       [ngStyle]="{'width.px':widthPhoto, 'height.px': this.heightPhoto, 'margin-top.px':this.topPhoto,'margin-left.px':this.leftPhoto}">
    <h3>Widok okładki:</h3>
    <lib-cover
      [imageSize]="imageSize"
      [point]="point"
      [url]="url"
    ></lib-cover>
  </div>
</div>
